var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2048,
    height: 2048,
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M2048 670v898q0 51-22 92t-59 70t-82 46t-93 16q-47 0-93-16t-82-45t-58-71t-23-92q0-51 22-92t59-71t82-45t93-16q66 0 128 31V834l-640 160v702q0 51-22 92t-59 70t-82 46t-93 16q-47 0-93-16t-82-45t-58-71t-23-92q0-51 22-92t59-71t82-45t93-16q66 0 128 31V894l896-224zM1024 1792q20 0 42-6t42-18t31-30t13-42q0-24-12-42t-32-30t-41-18t-43-6q-20 0-42 6t-42 18t-31 30t-13 42q0 24 12 42t32 30t41 18t43 6zm768-128q20 0 42-6t42-18t31-30t13-42q0-24-12-42t-32-30t-41-18t-43-6q-20 0-42 6t-42 18t-31 30t-13 42q0 24 12 42t32 30t41 18t43 6zM384 640H256V512h128v128zM256 768h128v128H256V768zm896-256h128v128h-128V512zm-128 768H0V128h1536v512l-128 32V256h-128v128h-128V256H384v128H256V256H128v896h128v-128h128v128h640v128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlaceholder);
export default __webpack_public_path__ + "static/media/mediaPlaceholder.09e8772a84e57ea392772a54ac6ce187.svg";
export { ForwardRef as ReactComponent };